import { render, staticRenderFns } from "./AttendanceDashboard.vue?vue&type=template&id=5ffd7fc4&"
import script from "./AttendanceDashboard.vue?vue&type=script&lang=js&"
export * from "./AttendanceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports